import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {HttpApiService} from '../../../services/http-api.service';
import {EndpointsService} from '../../../services/endpoints.service';
import { URLSearchParams } from '@angular/http';
import {AlertMessageComponent, AlertType} from "../../../shared/alert-message/alert-message.component";
import {TenantService} from '../../../services/tenant.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-app-inquiry',
  templateUrl: './app-inquiry.component.html',
  styleUrls: ['./app-inquiry.component.scss']
})
export class AppInquiryComponent implements OnInit {

  firstName = '';
  lastName = '';
  phoneNumber = '';
  emailId = '';
  company = '';
  location = '';
  appName = '';
  supportIssue = '';
  tenant;
  @Input('subject') subject;
  @Output() isEmailSent = new EventEmitter();
  isUpdating = false;

  constructor(private api: HttpApiService, private endpoints: EndpointsService,
  private tenantService: TenantService, private route: ActivatedRoute, private router : Router) {
  }

  ngOnInit() {
    this.clearForm();
    const self = this;
    self.tenantService.getTenantWithPromise().then((response) => {
      self.tenant = response;
    });
    var parts = this.router.url.split("/");
    this.appName = parts[parts.length - 1];
  }

  sendNotification() {
    this.isUpdating = true;
    const data = {
      'firstName': this.firstName,
      'location': this.location,
      'lastName': this.lastName,
      'company': this.company,
      'emailId': this.emailId,
      'subject': this.subject,
      'phoneNumber': this.phoneNumber,
      'domain': this.tenant.domain,
      'appName': this.appName,
      'supportIssue': this.supportIssue
    }
    console.log("subject "+this.subject);
    this.api.post(this.endpoints.sendEmailNotificationUrl(), data, false)
      .subscribe(response => {
          this.isUpdating = false;
          this.isEmailSent.emit({'isEmailSent': true});
          AlertMessageComponent.open(AlertType.Success, 'Reqest has been sent successfully.');
        },
        error => {
          this.isUpdating = false;
          AlertMessageComponent.open(AlertType.Error, 'Message Sending Failure');
        });
  }

  clearForm() {
    this.firstName = '';
    this.lastName = '';
    this.phoneNumber = '';
    this.emailId = '';
    this.company = '';
    this.location = '';
  }
}



// WEBPACK FOOTER //
// ./src/app/components/app-profile/app-inquiry/app-inquiry.component.ts